/**
 *  The Application Programming Interface (API) is the collection of
 *  functions, classes and types offered by the Ethers library.
 *
 *  @_section: api:Application Programming Interface  [about-api]
 *  @_navTitle: API
 */
import * as ethers from "./ethers.js";
export { ethers };
export * from "./ethers.js";
//# sourceMappingURL=index.js.map